module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="selected-unit" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n    <div class="selected-unit-path"></div>\n    <div class="selected-unit-name">' +
__e( data.name ) +
'</div>\n</div>\n<div class="expand-unit-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n    <i class="fas fa-chevron-down bu-switch-icon"></i>\n</div>\n<div class="dropdown-menu" aria-labelledby="businessUnitSelector">\n    <div class="typeahead-cont"><i class="fal fa-search search-icon"></i><input type="text" class="typeahead" placeholder="Search" />\n        ';
 if (data.isBUExport) { ;
__p += '<div class="export" data-toggle="tooltip" data-placement="bottom" title="' +
((__t = ( strings.exportBUTooltip )) == null ? '' : __t) +
'"><i class="far download-icon fa-arrow-to-bottom"></i></div>';
 } ;
__p += '\n        ';
 if (data.hasBUManage) { ;
__p += '<div class="manager" data-toggle="tooltip" data-placement="bottom" title="' +
((__t = ( strings.managerBUTooltip )) == null ? '' : __t) +
'"><i class="fal manager-icon fa-cog"></i></div>';
 } ;
__p += '\n    </div>\n    <div class="business-units"></div>\n</div>\n';
return __p
}